// assets/faq-chatbot.js
// CléScan™ — Widget chatbot FAQ, présent sur toutes les pages du site.
// Charge via {{ 'faq-chatbot.js' | asset_url }} dans snippets/faq-chatbot.liquid

(function () {
  "use strict";

  var EDGE_FUNCTION_URL = "https://xhqjseldlxzwqgxxdzhn.supabase.co/functions/v1/faq-bot";
  // Aucune clé requise : cette fonction accepte les appels publics
  // (verify_jwt désactivé côté Supabase, exprès, car le visiteur est anonyme).

  var STORAGE_KEY = "clescan_faq_chat_history";
  var state = {
    open: false,
    loading: false,
    history: [], // { role: 'user' | 'assistant', content: string }
  };

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (key === "class") node.className = attrs[key];
        else if (key === "html") node.innerHTML = attrs[key];
        else node.setAttribute(key, attrs[key]);
      });
    }
    (children || []).forEach(function (child) {
      if (child) node.appendChild(child);
    });
    return node;
  }

  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      state.history = raw ? JSON.parse(raw) : [];
    } catch (e) {
      state.history = [];
    }
  }

  function saveHistory() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state.history));
    } catch (e) {
      /* stockage indisponible, on continue sans persistance */
    }
  }

  function scrollToBottom(container) {
    container.scrollTop = container.scrollHeight;
  }

  function renderMessage(container, role, text) {
    var bubble = el("div", {
      class: "cs-faq-msg cs-faq-msg--" + role,
    });
    bubble.textContent = text;
    container.appendChild(bubble);
    scrollToBottom(container);
    return bubble;
  }

  function renderTyping(container) {
    var typing = el("div", { class: "cs-faq-msg cs-faq-msg--assistant cs-faq-typing" }, [
      el("span", {}),
      el("span", {}),
      el("span", {}),
    ]);
    container.appendChild(typing);
    scrollToBottom(container);
    return typing;
  }

  async function sendMessage(container, input, sendBtn, text) {
    if (state.loading || !text.trim()) return;

    state.loading = true;
    input.value = "";
    input.disabled = true;
    sendBtn.disabled = true;

    renderMessage(container, "user", text);
    state.history.push({ role: "user", content: text });
    saveHistory();

    var typingEl = renderTyping(container);

    try {
      var response = await fetch(EDGE_FUNCTION_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: text,
          history: state.history.slice(0, -1),
        }),
      });

      var data = await response.json();
      typingEl.remove();

      var reply =
        data && data.reply
          ? data.reply
          : "Désolé, je rencontre un souci technique. Vous pouvez contacter notre équipe directement : support@clescan.fr";

      renderMessage(container, "assistant", reply);
      state.history.push({ role: "assistant", content: reply });
      saveHistory();
    } catch (err) {
      typingEl.remove();
      var fallback =
        "Désolé, je rencontre un souci de connexion. Vous pouvez contacter notre équipe directement : support@clescan.fr";
      renderMessage(container, "assistant", fallback);
      state.history.push({ role: "assistant", content: fallback });
      saveHistory();
    } finally {
      state.loading = false;
      input.disabled = false;
      sendBtn.disabled = false;
      input.focus();
    }
  }

  function buildWidget() {
    loadHistory();

    var root = el("div", { class: "cs-faq-widget", id: "cs-faq-widget" });

    var bubbleBtn = el("button", {
      class: "cs-faq-bubble",
      type: "button",
      "aria-label": "Ouvrir l'assistance CléScan™",
    });
    bubbleBtn.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 3C7.03 3 3 6.58 3 11c0 2.39 1.19 4.53 3.06 6.02-.1.99-.5 2.24-1.31 3.48a.4.4 0 0 0 .43.6c1.83-.42 3.35-1.16 4.34-1.77.78.18 1.6.27 2.48.27 4.97 0 9-3.58 9-8s-4.03-8-9-8Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '<circle cx="8.6" cy="11" r="1" fill="currentColor"/>' +
      '<circle cx="12" cy="11" r="1" fill="currentColor"/>' +
      '<circle cx="15.4" cy="11" r="1" fill="currentColor"/>' +
      '</svg>';

    var panel = el("div", { class: "cs-faq-panel", role: "dialog", "aria-label": "Assistant CléScan™" });

    var header = el("div", { class: "cs-faq-header" }, [
      el("div", { class: "cs-faq-header-text" }, [
        el("strong", { html: "Assistance CléScan\u2122" }),
      ]),
      el("button", {
        class: "cs-faq-close",
        type: "button",
        "aria-label": "Fermer l'assistant",
        html: "&times;",
      }),
    ]);

    var messagesContainer = el("div", { class: "cs-faq-messages" });

    if (state.history.length === 0) {
      renderMessage(messagesContainer, "assistant", "Bonjour, comment puis-je vous aider ?");
    } else {
      state.history.forEach(function (m) {
        renderMessage(messagesContainer, m.role, m.content);
      });
    }

    var inputRow = el("div", { class: "cs-faq-input-row" });
    var input = el("input", {
      type: "text",
      class: "cs-faq-input",
      placeholder: "Pose ta question...",
      "aria-label": "Écrire un message à l'assistant",
    });
    var sendBtn = el("button", {
      class: "cs-faq-send",
      type: "button",
      "aria-label": "Envoyer",
    });
    sendBtn.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M4 12h16M14 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>";

    inputRow.appendChild(input);
    inputRow.appendChild(sendBtn);

    panel.appendChild(header);
    panel.appendChild(messagesContainer);
    panel.appendChild(inputRow);

    root.appendChild(panel);
    root.appendChild(bubbleBtn);
    document.body.appendChild(root);

    function openPanel() {
      state.open = true;
      root.classList.add("cs-faq-open");
      bubbleBtn.setAttribute("aria-expanded", "true");
      // Sur mobile, on n'ouvre pas le clavier automatiquement : ça laisse le temps
      // de voir la conversation avant que le clavier ne prenne de la place.
      if (!isMobile()) {
        setTimeout(function () {
          input.focus();
        }, 150);
      }
      adjustPanelForViewport();
    }

    function closePanel() {
      state.open = false;
      root.classList.remove("cs-faq-open");
      bubbleBtn.setAttribute("aria-expanded", "false");
    }

    function isMobile() {
      return window.matchMedia("(max-width: 480px)").matches;
    }

    // Sur mobile, le clavier virtuel ne redimensionne pas la fenêtre comme sur
    // desktop : on suit la taille réelle visible (visualViewport) pour que le
    // panneau ne soit jamais caché derrière le clavier, et pour laisser assez
    // de place à la conversation pendant qu'on tape.
    function adjustPanelForViewport() {
      if (!isMobile() || !state.open || !window.visualViewport) return;
      var vv = window.visualViewport;
      var keyboardOffset = window.innerHeight - vv.height - vv.offsetTop;
      panel.style.height = Math.max(vv.height - 24, 220) + "px";
      root.style.bottom = Math.max(keyboardOffset + 12, 12) + "px";
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", adjustPanelForViewport);
      window.visualViewport.addEventListener("scroll", adjustPanelForViewport);
    }

    bubbleBtn.addEventListener("click", function () {
      state.open ? closePanel() : openPanel();
    });
    header.querySelector(".cs-faq-close").addEventListener("click", closePanel);

    sendBtn.addEventListener("click", function () {
      sendMessage(messagesContainer, input, sendBtn, input.value);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        sendMessage(messagesContainer, input, sendBtn, input.value);
      }
    });
    input.addEventListener("focus", function () {
      setTimeout(adjustPanelForViewport, 300);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", buildWidget);
  } else {
    buildWidget();
  }
})();